import { Link } from 'gatsby';
import React from 'react';

// @ts-ignore
import * as styles from './Header.module.scss';

interface Props {
  siteTitle: string;
}
export const Header = ({ siteTitle }: Props) => (
  <header className={styles.Header}>
    <div className={styles.HeaderWrapper}>
      <h1 style={{ margin: 0 }}>
        <Link to="/" className={styles.Link}>
          {siteTitle}
        </Link>
      </h1>
    </div>
  </header>
);
